import { Component, Input, OnInit } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import * as moment from 'moment';
// import core firebase client (required)
import { of } from 'rxjs';
import { BaseComponent } from 'src/app/shared/base/base.component';
import { FirebaseAuthComponent } from 'src/app/shared/firebase-auth/firebase-auth.component';
import { MessagesService } from 'src/app/shared/services/messages/message.service';
import { TutorService } from 'src/app/shared/services/tutor/tutor.service';
import { Formulario } from '../interface/fomulario';
import { Student } from '../tiposFormulario/student';
import { NewInscription } from './../tiposFormulario/students/new-inscription';


@Component({
  selector: 'app-student',
  templateUrl: './student.component.html'
})
export class StudentComponent extends BaseComponent implements OnInit {

  @Input()
  public user;
  public userAuth;

  public student = new Student();
  public dobModified: string;
  public ageModified: number;
  public cargando = false;

  public inscription = new NewInscription();

  public readonly chevronLeft = faChevronLeft;
  public readonly chevronRight = faChevronRight;

  constructor(public firebaseAuth: FirebaseAuthComponent,
              private router: Router,
              private firestore: AngularFirestore,
              private messageService: MessagesService,
              private tutorService: TutorService) {

      super();
  }

  ngOnInit(): void {
    console.log('el user en students es ', this.user);
    console.log('los estudiantes son ', this.students);
  }

  getDate(dob: any): any {
    if (dob) {
      const date = (dob.seconds) ? new Date(dob.seconds * 1000) : dob;
      const day = (date.getDate() < 10) ? '0' + date.getDate() : date.getDate();
      const month = (date.getMonth() < 10) ? '0' + (date.getMonth() + 1) : (date.getMonth() + 1);
      return day + '-' + month + '-' + date.getFullYear();
    }
    return '';
  }

  getSchedules(course: any): any {
    const startTime = moment().hours(course.startTime.hour).minutes(course.startTime.minute).format('HH:mm');
    const endTime = moment().hours(course.endTime.hour).minutes(course.endTime.minute).format('HH:mm');
    return this.showCourseDays(course)  + ' ' + startTime + '-' + endTime + ' h';
  }

  async modificar(title: string, boldTitle: string = null, formulario: Formulario, idStudent: string): Promise<any> {
    const formBuilt: any[] = formulario.createFormulario();
    for (const form of formBuilt) {
      if (form.element === 'select' && form.reference) {
        const collection = await this.firestore.collection(form.reference).get().toPromise();
        collection.forEach(value => {
          let valueRef = value.id;
          if (form.referenceValue !== 'id') {
            valueRef = value.data()[form.referenceValue];
          }
          form.options.push({ value: valueRef, key: value.data() });
        });
      }
    }
    const functionToSave = (formGroup: FormGroup, form: any[], ...params) => {
      const formToSave: any = {};
      const id = params[0][0];
      form.forEach(elem => {
        if (!elem.notSave) {
          if (elem.reference && elem.referenceValue === 'id') {
            const ref = this.firestore.collection(elem.reference).doc(formGroup.value[elem.name]).ref;
            formToSave[elem.name] = ref;
          } else if (formGroup.value[elem.name]) {
            if (elem.element === 'date') {
              const date = new Date(formGroup.value[elem.name].year, formGroup.value[elem.name].month,
                formGroup.value[elem.name].day);
              const age = this.calcularEdadAlumno(date);
              formToSave.age = age;
              formToSave[elem.name] = date;
            } else {
              formToSave[elem.name] = formGroup.value[elem.name];
            }
          }
        }
      });
      return Promise.all([this.firestore.collection('users').doc(id).update(formToSave), of(formToSave).toPromise()]);
    };

    console.log('el formulario después es ', formBuilt);
    this.messageService.showFormInDialog(formBuilt, title, boldTitle, functionToSave, 'date-dialog-class', 'Guardado Correctamente',
      idStudent).afterClosed()
      .subscribe(x => {
        if (x !== true) {
          this.messageService.openAlertDialog(x.message, 'Respuesta');
          console.log('la info es ', x);
          this.students[this.studentCurrent].dob = x.object[1].dob;
          this.students[this.studentCurrent].age = x.object[1].age;
        }
      });
  }

  async newInscription(): Promise<any> {
    const formBuilt: any[] = this.inscription.createFormulario(this.students);

    const functionToExecute = (formGroup: FormGroup, form: any[], id: string) => {
      return of(formGroup).toPromise();
    };

    console.log('el formulario después es ', formBuilt);
    this.messageService.showFormInDialog(formBuilt, 'Inscripción', 'NUEVA', functionToExecute).afterClosed()
      .subscribe(x => {
        if (x !== true) {
          let flag = false;
          const arrPromises = [];
          this.students.forEach((student, index) => {
            const studentValue = 'student_' + index;
            if (x.object.value.students.filter(stu => stu === studentValue).length > 0) {
              flag = true;
              console.log('el id del tutor es ', this.user.id, 'el estudent elegido es ', student);
              arrPromises.push(this.firestore.collection('users').doc(student.id)
                .ref.update({ isNewInscription: true, emaiSend: null }));
            }
          });
          if (flag) {
            this.cargando = true;
            Promise.all(arrPromises)
              .then(ejecutado => {
                this.cargando = false;
                console.log('fue ejecutado y todo bien ', ejecutado);
                this.router.navigate([`/infoacademica`]);
                setTimeout(() => {
                  this.tutorService.changeIdTutor(this.user.id);
                }, 500);
              })
              .catch(error => {
                this.messageService.openAlertDialog(error, 'HUbo un error modificando los alumnos');
              });
          } else if (x.object.value.students[0] === 'otro') {
            console.log('fue elegido otro');
            console.log('el id del tutor es ', this.user.id);
            this.router.navigate([`/registro`]);
            setTimeout(() => {
              this.tutorService.changeIdTutor(this.user.id);
            }, 500);
          }
        }
      });
  }

  calcularEdadAlumno(dob: Date): number {
    if (dob != null) {
      const timeDiff = Math.abs(Date.now() - dob.getTime());
      const age = Math.floor((timeDiff / (1000 * 3600 * 24)) / 365.25);
      return age;
    }
  }

  getDataFromStatusCourses(idCourse: string, property: string): string {
    const status = this.students[this.studentCurrent].statusCourses
      .filter(x => x.idStatus === '/courses/' + idCourse || x.idStatus === 'courses/' + idCourse);

    return status[0][property];
  }

  getCourse(id: string): string {
    const status = this.students[this.studentCurrent].statusCourses
    .filter(x => x.idStatus === `/courses/${id}` || x.idStatus === `courses/${id}`)
    .orElse([{courseStatus: 'Sin estado'}])[0];

    return (status.courseStatus === 'test') ? 'Prueba' : status.courseStatus;
  }
}
